var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { toQuery } from '@debbie/common/dist/util';
import { collectionEngineV1 } from '../apis';
const reqCases = collectionEngineV1('/case-vouchers');
export const getMultiple = (query, pagination) => reqCases('GET', `/?${toQuery(Object.assign(Object.assign({}, query), pagination))}`);
export const getByCaseId = (caseId, options) => reqCases('GET', `/${caseId}?${(options === null || options === void 0 ? void 0 : options.getDeleted) ? 'getDeleted=true' : ''}`);
export const getById = (id) => reqCases('GET', `/by-id/${id}`);
export const create = (caseId, newCaseVoucher, config) => reqCases('POST', `/${caseId}${(config === null || config === void 0 ? void 0 : config.preventAdjustments) ? '?preventAdjustments=true' : ''}`, {
    body: newCaseVoucher,
});
export const patchCaseVoucher = (caseVoucherId, patch, config) => reqCases('PATCH', `/${caseVoucherId}${(config === null || config === void 0 ? void 0 : config.preventAdjustments) ? '?preventAdjustments=true' : ''}`, {
    body: patch,
});
export const delCaseVoucher = (caseVoucherId, config) => reqCases('DELETE', `/${caseVoucherId}${(config === null || config === void 0 ? void 0 : config.preventAdjustments) ? '?preventAdjustments=true' : ''}`);
export const getDepositInsights = () => reqCases('GET', '/insights/deposits');
export const checkForDuplicates = (creditorId, vouchers) => __awaiter(void 0, void 0, void 0, function* () {
    return yield reqCases('POST', '/duplicates/' + creditorId, {
        body: { vouchers },
    });
});
//# sourceMappingURL=case-vouchers.js.map